"use strict";

angular.module("prisma")
  .controller("DeviationsCtrl", function ($scope, $timeout) {
      var self = this;
      self.section = "Inicio";
      self.name = "Analisis de Desvios";
  });
